var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"login-card",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"login-btn",on:{"click":_vm.goToLogin}},[_vm._v(_vm._s(_vm.$t('userMenu.login')))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }